const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'S2_LOCALES_SUCCESS') {
        return {
            ...state,
            [action.actionParams.environment]: {
                ...state[action.actionParams.environment],
                locales: action.payload,
            },
        };
    }

    if (action.type === 'S2_APM_TYPES_SUCCESS') {
        return {
            ...state,
            [action.actionParams.environment]: {
                ...state[action.actionParams.environment],
                apmTypes: action.payload,
            },
        };
    }

    if (action.type === 'S2_LOCALES_FAILURE') {
        return {
            ...state,
            [action.actionParams.environment]: {
                ...state[action.actionParams.environment],
                locales: null,
            },
        };
    }

    if (action.type === 'S2_APM_TYPES_FAILURE') {
        return {
            ...state,
            [action.actionParams.environment]: {
                ...state[action.actionParams.environment],
                apmTypes: null,
            },
        };
    }

    return state;
}

export default reducer;
